import React, { createContext, useContext, useEffect, useState } from 'react';
import webSocketService  from './Components/webSocketService';

const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children }) => {
  const [wsUrl, setWsUrl] = useState(null);

  useEffect(() => {
    fetch('/config.json')
      .then(res => res.json())
      .then(cfg => {
        const urlObj = cfg.dataNeed.find(x => x.ServerUrl);
        if (urlObj && urlObj.ServerUrl) {
          // Μετατροπή σε ws:// ή wss:// και προσθήκη /ws
          let wsUrl = urlObj.ServerUrl;
          if (wsUrl.startsWith('https://')) {
            wsUrl = 'wss://' + wsUrl.slice(8);
          } else if (wsUrl.startsWith('http://')) {
            wsUrl = 'ws://' + wsUrl.slice(7);
          }
          if (!wsUrl.endsWith('/ws')) {
            wsUrl += '/ws';
          }
          setWsUrl(wsUrl);
        }
      });
  }, []);

  useEffect(() => {
    if (!wsUrl) return;
      webSocketService.connect(wsUrl);

    return () => {
      webSocketService.close();
    };
  }, [wsUrl]);

  return (
    <WebSocketContext.Provider value={webSocketService}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocket = () => {
  const context = useContext(WebSocketContext);
  if (!context) {
    throw new Error('useWebSocket πρέπει να χρησιμοποιείται μέσα από <WebSocketProvider>');
  }
  return context;
};